import React from 'react';

import isNumber from 'lodash/isNumber';

import { Tab as UITab, Tabs as UITabs } from '@gogame/components';
import { useNumberFormat } from '@gogame/intl-ts';

import { useAttachments } from 'scenes/Gallery/GalleryPage/ConceptFamilies/data';
import {
  TAB_DETAILS,
  TAB_ATTACHMENTS,
} from 'scenes/Gallery/GalleryPage/constants';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

const TabLabel = ({ name, count }) => {
  const format = useNumberFormat();
  return `${name}${isNumber(count) ? ` (${format(count)})` : ''}`;
};

const Tabs = ({ conceptFamilyId, activeTab, onChange }) => {
  const { data: attachments } = useAttachments({ id: conceptFamilyId });

  const { isAllowAttachments } = useGalleryPermissions();

  const handleTabChange = (_e, newActiveTabId) => {
    onChange(newActiveTabId);
  };

  return (
    <UITabs value={activeTab} onChange={handleTabChange}>
      <UITab
        key={TAB_DETAILS}
        value={TAB_DETAILS}
        label={<TabLabel name={'Details'} />}
        data-cy-label={'Details'}
      />
      {isAllowAttachments ? (
        <UITab
          key={TAB_ATTACHMENTS}
          value={TAB_ATTACHMENTS}
          label={<TabLabel name={'Attachments'} count={attachments?.length} />}
          data-cy-label={'Attachments'}
        />
      ) : null}
    </UITabs>
  );
};
export default Tabs;
